import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "subheader-icon fal fa-users" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = { class: "panel-hdr mt-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Datos de la "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-300" }, [
    /*#__PURE__*/_createElementVNode("i", null, "Compra")
  ])
], -1)
const _hoisted_10 = { class: "panel-toolbar" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus-square" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-block float-right ml-1" }, "Nueva", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "panel-container" }
const _hoisted_15 = { class: "panel-content pb-2" }
const _hoisted_16 = { class: "form-row align-items-end" }
const _hoisted_17 = { class: "col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "id_proveedor"
}, "Proveedor", -1)
const _hoisted_19 = {
  key: 0,
  class: "invalid-feedback-select2"
}
const _hoisted_20 = { class: "col-xl-2 col-lg-2 col-md-3 col-sm-6 col-6 mb-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "fecha_compra"
}, "Fecha", -1)
const _hoisted_22 = ["readonly"]
const _hoisted_23 = {
  key: 0,
  class: "invalid-feedback-select2"
}
const _hoisted_24 = { class: "col-xl-2 col-lg-2 col-md-3 col-sm-6 col-6 mb-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "id_tipo_pago"
}, "Tipo pago", -1)
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback-select2"
}
const _hoisted_27 = { class: "col-xl-2 col-lg-2 col-md-3 col-sm-6 col-6 mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "total"
}, "Total", -1)
const _hoisted_29 = { class: "col-xl-2 col-lg-2 col-md-3 col-sm-6 col-6 mb-2 d-flex align-items-end" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-save mr-1" }, null, -1)
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-xl-12" }
const _hoisted_34 = { class: "panel" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr mt-2" }, [
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createTextVNode("Detalle de "),
    /*#__PURE__*/_createElementVNode("span", { class: "fw-300" }, [
      /*#__PURE__*/_createElementVNode("i", null, "Productos")
    ])
  ])
], -1)
const _hoisted_36 = { class: "panel-container" }
const _hoisted_37 = { class: "panel-content mb-0 pb-0" }
const _hoisted_38 = { class: "row mb-2" }
const _hoisted_39 = { class: "col-xl-3 col-lg-3 col-md-4 col-sm-5 col-12" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "filtro_codigo_barras"
}, "Código de barras", -1)
const _hoisted_41 = { class: "input-group" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-barcode" })
  ])
], -1)
const _hoisted_43 = ["readonly"]
const _hoisted_44 = { class: "col-xl-5 col-lg-5 col-md-6 col-sm-7 col-12" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "filtro_nombre_producto"
}, "Nombre producto", -1)
const _hoisted_46 = { class: "table-responsive" }
const _hoisted_47 = { class: "table table-bordered table-sm" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"50px"}
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center"
    }, "Producto"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"110px"}
    }, "Cantidad"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"120px"}
    }, "P/Compra"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"120px"}
    }, "P/Venta"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"120px"}
    }, "Importe"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"120px"}
    }, "Lote"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"140px"}
    }, "F. Vencimiento"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center",
      style: {"width":"30px"}
    })
  ])
], -1)
const _hoisted_49 = {
  scope: "row",
  class: "text-right",
  style: {"padding-top":"12px"}
}
const _hoisted_50 = { style: {"padding-top":"12px"} }
const _hoisted_51 = {
  class: "text-right",
  style: {"padding-top":"12px"}
}
const _hoisted_52 = {
  class: "text-right",
  style: {"padding-top":"12px"}
}
const _hoisted_53 = {
  class: "text-right",
  style: {"padding-top":"12px"}
}
const _hoisted_54 = {
  class: "text-right",
  style: {"padding-top":"12px"}
}
const _hoisted_55 = {
  class: "text-center",
  style: {"padding-top":"12px"}
}
const _hoisted_56 = {
  class: "text-center",
  style: {"padding-top":"12px"}
}
const _hoisted_57 = { class: "text-center" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-trash-alt" }, null, -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  key: 0,
  class: "bg-warning-50"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "text-right",
  style: {"padding-top":"12px"}
}, "-", -1)
const _hoisted_63 = { style: {"padding-top":"12px"} }
const _hoisted_64 = { class: "text-right" }
const _hoisted_65 = { class: "text-right" }
const _hoisted_66 = { class: "text-right" }
const _hoisted_67 = { class: "text-right" }
const _hoisted_68 = ["min"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", null, " ", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  colspan: "5",
  class: "text-right"
}, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-bold" }, "TOTAL")
], -1)
const _hoisted_71 = { class: "text-right" }
const _hoisted_72 = { class: "font-weight-bold" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-content-overlay",
  "data-action": "toggle",
  "data-class": "mobile-nav-on"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select2 = _resolveComponent("Select2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm mr-2",
                  title: "Nueva compra",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.nuevaCompra && $setup.nuevaCompra(...args)))
                }, _hoisted_13)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_Select2, {
                      id: "id_proveedor",
                      name: "id_proveedor",
                      class: _normalizeClass({ 'input-validation-error-select2': $setup.v$.id_proveedor.$dirty && $setup.v$.id_proveedor.$invalid }),
                      modelValue: $setup.v$.id_proveedor.$model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.v$.id_proveedor.$model) = $event)),
                      options: $setup.proveedores,
                      disabled: $setup.seGrabo,
                      settings: { multiple: false, placeholder: 'Seleccione', width: '100%', tags: false }
                    }, null, 8, ["class", "modelValue", "options", "disabled"]),
                    ($setup.v$.id_proveedor.$dirty && $setup.v$.id_proveedor.required.$invalid)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_19, " Proveedor, no tiene información. "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: _normalizeClass(["form-control form-control-sm", { 'input-validation-error-select2': $setup.v$.fecha_compra.$dirty && $setup.v$.fecha_compra.$invalid }]),
                      id: "fecha_compra",
                      name: "fecha_compra",
                      readonly: $setup.seGrabo,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.v$.fecha_compra.$model) = $event))
                    }, null, 10, _hoisted_22), [
                      [_vModelText, $setup.v$.fecha_compra.$model]
                    ]),
                    ($setup.v$.fecha_compra.$dirty && $setup.v$.fecha_compra.required.$invalid)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_23, " Fecha, no tiene información. "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode(_component_Select2, {
                      id: "id_tipo_pago",
                      name: "id_tipo_pago",
                      class: _normalizeClass({ 'input-validation-error-select2': $setup.v$.id_tipo_pago.$dirty && $setup.v$.id_tipo_pago.$invalid }),
                      modelValue: $setup.v$.id_tipo_pago.$model,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.v$.id_tipo_pago.$model) = $event)),
                      disabled: $setup.seGrabo,
                      options: $setup.tiposPago,
                      settings: { multiple: false, placeholder: 'Seleccione', width: '100%', tags: false }
                    }, null, 8, ["class", "modelValue", "disabled", "options"]),
                    ($setup.v$.id_tipo_pago.$dirty && $setup.v$.id_tipo_pago.required.$invalid)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_26, " Tipo pago, no tiene información. "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm text-right font-weight-bold",
                      id: "total",
                      name: "total",
                      autocomplete: "off",
                      readonly: true,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.compra.total) = $event))
                    }, null, 512), [
                      [_vModelText, $setup.compra.total]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-warning btn-sm w-100",
                      title: "Grabar compra",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.grabarCompraFunction && $setup.grabarCompraFunction(...args))),
                      disabled: $setup.compra.comprasDetalle.length === 0 || $setup.seGrabo,
                      accesskey: "g"
                    }, [
                      _hoisted_31,
                      _createTextVNode(" Grabar [Alt+g] ")
                    ], 8, _hoisted_30)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "filtro_codigo_barras",
                        name: "filtro_codigo_barras",
                        class: "form-control form-control-sm",
                        placeholder: "Buscar producto",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.filtroCodigoBarras) = $event)),
                        onKeypress: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => ($setup.buscarProducto && $setup.buscarProducto(...args)), ["enter"])),
                        readonly: $setup.seGrabo,
                        ref: "filtroProductoRef"
                      }, null, 40, _hoisted_43), [
                        [
                          _vModelText,
                          $setup.filtroCodigoBarras,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode(_component_Select2, {
                      id: "filtro_nombre_producto",
                      name: "filtro_nombre_producto",
                      options: $setup.productos,
                      "aria-placeholder": "Seleccione",
                      modelValue: $setup.filtroNombreProducto,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.filtroNombreProducto) = $event)),
                      settings: { multiple: false, placeholder: 'Seleccione', width: '100%', tags: false },
                      onSelect: $setup.asignarProductoSeleccionado
                    }, null, 8, ["options", "modelValue", "onSelect"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("table", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.compra.comprasDetalle, (compraDetalleItem, i) => {
                        return (_openBlock(), _createElementBlock("tr", { key: i }, [
                          _createElementVNode("th", _hoisted_49, _toDisplayString(i + 1), 1),
                          _createElementVNode("td", _hoisted_50, _toDisplayString(compraDetalleItem.nombre_producto), 1),
                          _createElementVNode("td", _hoisted_51, _toDisplayString(compraDetalleItem.cantidad), 1),
                          _createElementVNode("td", _hoisted_52, _toDisplayString($setup.numeral(compraDetalleItem.precio_compra).format('0,0.00')) + ".- ", 1),
                          _createElementVNode("td", _hoisted_53, _toDisplayString($setup.numeral(compraDetalleItem.precio_venta).format('0,0.00')) + ".- ", 1),
                          _createElementVNode("td", _hoisted_54, _toDisplayString($setup.numeral(compraDetalleItem.importe).format('0,0.00')) + ".- ", 1),
                          _createElementVNode("td", _hoisted_55, _toDisplayString(compraDetalleItem.numero_lote || '-'), 1),
                          _createElementVNode("td", _hoisted_56, _toDisplayString($setup.formatFecha(compraDetalleItem.fecha_vencimiento)), 1),
                          _createElementVNode("td", _hoisted_57, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-xs",
                              title: "Eliminar",
                              onClick: ($event: any) => ($setup.eliminarDetalleFactura(i))
                            }, _hoisted_60, 8, _hoisted_58)
                          ])
                        ]))
                      }), 128)),
                      ($setup.compraDetalle.id_producto > 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_61, [
                            _hoisted_62,
                            _createElementVNode("td", _hoisted_63, _toDisplayString($setup.compraDetalle.nombre_producto), 1),
                            _createElementVNode("td", _hoisted_64, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "cantidad",
                                name: "cantidad",
                                class: _normalizeClass(["form-control form-control-sm text-right", { 'is-invalid': $setup.vcd$.cantidad.$dirty && $setup.vcd$.cantidad.$invalid }]),
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.vcd$.cantidad.$model) = $event)),
                                onFocus: _cache[10] || (_cache[10] = ($event: any) => {$event.target.select();}),
                                onKeyup: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.calcularImporte && $setup.calcularImporte(...args))),
                                onKeypress: [
                                  _cache[12] || (_cache[12] = ($event: any) => ($setup.keyPressCantidad($event))),
                                  _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => ($setup.adicionarDetalleVenta && $setup.adicionarDetalleVenta(...args)), ["enter"]))
                                ],
                                ref: "cantidadRef"
                              }, null, 34), [
                                [_vModelText, $setup.vcd$.cantidad.$model]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_65, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "precio_compra",
                                name: "precio_compra",
                                class: _normalizeClass(["form-control form-control-sm text-right", { 'is-invalid': $setup.vcd$.precio_compra.$dirty && $setup.vcd$.precio_compra.$invalid }]),
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.vcd$.precio_compra.$model) = $event)),
                                onKeyup: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => ($setup.calcularImporte && $setup.calcularImporte(...args))),
                                onKeypress: [
                                  _cache[16] || (_cache[16] = ($event: any) => ($setup.keyPressPrecioCompra($event))),
                                  _cache[17] || (_cache[17] = _withKeys(
//@ts-ignore
(...args) => ($setup.adicionarDetalleVenta && $setup.adicionarDetalleVenta(...args)), ["enter"]))
                                ]
                              }, null, 34), [
                                [_vModelText, $setup.vcd$.precio_compra.$model]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_66, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "precio_venta",
                                name: "precio_venta",
                                class: _normalizeClass(["form-control form-control-sm text-right", { 'is-invalid': $setup.vcd$.precio_venta.$dirty && $setup.vcd$.precio_venta.$invalid }]),
                                style: {"background-color":"#d4edda","font-weight":"600"},
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.vcd$.precio_venta.$model) = $event)),
                                onFocus: _cache[19] || (_cache[19] = ($event: any) => {$event.target.select();}),
                                onKeypress: [
                                  _cache[20] || (_cache[20] = ($event: any) => ($setup.keyPressPrecioVenta($event))),
                                  _cache[21] || (_cache[21] = _withKeys(
//@ts-ignore
(...args) => ($setup.adicionarDetalleVenta && $setup.adicionarDetalleVenta(...args)), ["enter"]))
                                ]
                              }, null, 34), [
                                [_vModelText, $setup.vcd$.precio_venta.$model]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_67, _toDisplayString($setup.numeral($setup.compraDetalle.importe).format('0,0.00')) + ".- ", 1),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "numero_lote",
                                name: "numero_lote",
                                class: "form-control form-control-sm",
                                placeholder: "Opcional",
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.compraDetalle.numero_lote) = $event)),
                                onKeypress: _cache[23] || (_cache[23] = _withKeys(
//@ts-ignore
(...args) => ($setup.adicionarDetalleVenta && $setup.adicionarDetalleVenta(...args)), ["enter"]))
                              }, null, 544), [
                                [_vModelText, $setup.compraDetalle.numero_lote]
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                id: "fecha_vencimiento",
                                name: "fecha_vencimiento",
                                class: "form-control form-control-sm",
                                min: $setup.fechaHoy,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.compraDetalle.fecha_vencimiento) = $event)),
                                onKeypress: _cache[25] || (_cache[25] = _withKeys(
//@ts-ignore
(...args) => ($setup.adicionarDetalleVenta && $setup.adicionarDetalleVenta(...args)), ["enter"]))
                              }, null, 40, _hoisted_68), [
                                [_vModelText, $setup.compraDetalle.fecha_vencimiento]
                              ])
                            ]),
                            _hoisted_69
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("tr", null, [
                        _hoisted_70,
                        _createElementVNode("td", _hoisted_71, [
                          _createElementVNode("h5", _hoisted_72, _toDisplayString($setup.numeral($setup.compra.total).format('0,0.00')) + ".-", 1)
                        ]),
                        _hoisted_73
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_74
  ], 64))
}